import React, { createContext } from 'react';
import { useAddUserForm } from 'hooks/useAddUserForm';

const AddUserDataContext = createContext();
const allLocations = [
	{ location: 'No Access', key: 'six', tag: '' },
	// { location: 'Atlanta', key: 'one', tag: 'ATL' },
	{ location: 'Chattanooga', key: 'two', tag: 'CHA' },
	{ location: 'Huntsville', key: 'three', tag: 'HSV' },
	{ location: 'Birmingham', key: 'four', tag: 'BHM' },
	{ location: 'Greenville', key: 'five', tag: 'GSP' },
];

function AddUserDataProvider({
	children,
	data = {
		firstname: '',
		lastname: '',
		email: '',
		role: '',
		locations: [],
		selectableLocations: allLocations,
		badgeAccess: '',
		submitted: false,
		hasLocations: [],
	},
}) {
	const { inputs, change } = useAddUserForm(data);

	return (
		<AddUserDataContext.Provider value={{ inputs, change }}>{children}</AddUserDataContext.Provider>
	);
}

export { AddUserDataContext, AddUserDataProvider };
